!(function () {
  'use strict'
  function t (t, e) {
    var i = []
    if (t)
      return (
        t.forEach(function (t) {
          ~i.indexOf(t[e]) || i.push(t[e])
        }),
        i.map(function (t) {
          return { text: t, value: t }
        })
      )
  }
  angular
    .module('dataGrid', [])
    .filter('startFrom', function () {
      return function (t, e) {
        return t ? ((e = +e), t.slice(e)) : []
      }
    })
    .controller('gridController', [
      '$scope',
      '$rootScope',
      '$element',
      '$filter',
      '$location',
      'filtersFactory',
      function (e, i, r, n, a, o) {
        function s () {
          ;(e.urlSync || e.serverPagination) &&
            (e.serverPagination &&
              (clearTimeout(e.getDataTimeout),
              (e.getDataTimeout = setTimeout(p, e.getDataDelay))),
            e.filtered && l())
        }
        function c (t) {
          var i,
            r = !1
          ;(i = 'page=' + e.paginationOptions.currentPage),
            e.paginationOptions.itemsPerPage !==
              e.defaultsPaginationOptions.itemsPerPage &&
              (i += '&itemsPerPage=' + e.paginationOptions.itemsPerPage),
            e.sortOptions.predicate &&
              (i +=
                '&sort=' +
                encodeURIComponent(
                  e.sortOptions.predicate + '-' + e.sortOptions.direction
                )),
            e.filters.forEach(function (t) {
              var n = t.model,
                a = t.isInScope ? e.$eval(n) : e.$parent.$eval(n)
              if (t.disableUrl) return void (r = !0)
              if (a) {
                var o
                if (a instanceof Date) {
                  if (isNaN(a.getTime())) return
                  ;(o = a.getFullYear() + '-'),
                    (o +=
                      a.getMonth() < 9
                        ? '0' + (a.getMonth() + 1) + '-'
                        : a.getMonth() + 1 + '-'),
                    (o += a.getDate() < 10 ? '0' + a.getDate() : a.getDate()),
                    (a = o)
                }
                i += '&' + encodeURIComponent(n) + '=' + encodeURIComponent(a)
              }
            }),
            r && d(),
            a.search(i),
            t && e.$apply()
        }
        function l () {
          var t = a.search(),
            i = {}
          if (
            (Object.keys(t).forEach(function (e) {
              'page' !== e &&
                'sort' !== e &&
                'itemsPerPage' !== e &&
                (i[e] = t[e])
            }),
            e.filters.forEach(function (t) {
              var r = t.model,
                n = i[r]
              if (!t.disableUrl) {
                if (~t.filterType.toLowerCase().indexOf('date'))
                  return (
                    (e.$parent.__evaltmp = n ? new Date(n) : null),
                    void e.$parent.$eval(r + '=__evaltmp')
                  )
                'select' !== t.filterType || n || (n = ''),
                  n &&
                    (t.isInScope
                      ? ((e.__evaltmp = n), e.$eval(r + '=__evaltmp'))
                      : ((e.$parent.__evaltmp = n),
                        e.$parent.$eval(r + '=__evaltmp')))
              }
            }),
            (e.paginationOptions.itemsPerPage =
              e.defaultsPaginationOptions.itemsPerPage),
            (e.paginationOptions.currentPage =
              e.defaultsPaginationOptions.currentPage),
            t.itemsPerPage &&
              (e.paginationOptions.itemsPerPage = t.itemsPerPage),
            t.page &&
              (!e.serverPagination &&
              (t.page - 1) * e.paginationOptions.itemsPerPage >
                e.filtered.length
                ? (e.paginationOptions.currentPage = 1)
                : (e.paginationOptions.currentPage = t.page)),
            t.sort)
          ) {
            var r = t.sort.split('-')
            ;(e.sortOptions.predicate = decodeURIComponent(r[0])),
              (e.sortOptions.direction = decodeURIComponent(r[1]))
          }
          e.serverPagination || d()
        }
        function p () {
          var t = '',
            i = a.search()
          Object.keys(i).forEach(function (e) {
            t += e + '=' + i[e] + '&'
          }),
            (t = t.slice(0, -1)),
            !t && e.sortOptions.predicate
              ? e.sort(e.sortOptions.predicate, !0)
              : e._gridOptions.getData('?' + t, function (t, i) {
                  ;(e.filtered = t), (e.paginationOptions.totalItems = i)
                })
        }
        function d () {
          var t = Date.now(),
            i = !1
          ;(e._time = {}),
            e.sortOptions.predicate &&
            e.sortCache &&
            e.sortCache.predicate === e.sortOptions.predicate &&
            e.sortCache.direction === e.sortOptions.direction
              ? ((e.filtered = e.sortCache.data.slice()), (i = !0))
              : (e.filtered = e._gridOptions.data.slice()),
            (e._time.copy = Date.now() - t)
          var r = Date.now()
          g(), (e._time.filters = Date.now() - r)
          var a = Date.now()
          e.sortOptions.predicate &&
            !i &&
            ((e.filtered = n('orderBy')(
              e.filtered,
              e.sortOptions.predicate,
              'desc' === e.sortOptions.direction
            )),
            (e.sortCache = {
              data: e.filtered.slice(),
              predicate: e.sortOptions.predicate,
              direction: e.sortOptions.direction
            })),
            (e._time.sort = Date.now() - a),
            (e._time.all = Date.now() - t),
            (e.paginationOptions.totalItems = e.filtered.length)
        }
        function g () {
          e.filters.forEach(function (t) {
            var i = t.filterBy,
              r = t.model,
              n = t.isInScope ? e.$eval(r) : e.$parent.$eval(r),
              a = t.filterType
            if (e.customFilters[r])
              e.filtered = e.customFilters[r](e.filtered, n, i)
            else if (n && a) {
              var s = o.getFilterByType(a)
              s && (e.filtered = s(e.filtered, n, i))
            }
          })
        }
        ;(e._gridOptions = e.$eval(r.attr('grid-options'))),
          (e._gridActions = e.$eval(r.attr('grid-actions'))),
          (e.serverPagination = 'true' === r.attr('server-pagination')),
          (e.getDataDelay = r.attr('get-delay') || 350),
          e._gridActions ||
            (e.$parent.$eval(r.attr('grid-actions') + '= {}'),
            (e._gridActions = e.$parent.$eval(r.attr('grid-actions')))),
          (e._gridOptions.grid = e),
          (e.filtered = e._gridOptions.data.slice()),
          (e.paginationOptions = e._gridOptions.pagination
            ? angular.copy(e._gridOptions.pagination)
            : {}),
          (e.defaultsPaginationOptions = {
            itemsPerPage: e.paginationOptions.itemsPerPage,
            currentPage: e.paginationOptions.currentPage || 1
          }),
          (e.paginationOptions = angular.copy(e.defaultsPaginationOptions)),
          (e.sortOptions = e._gridOptions.sort
            ? angular.copy(e._gridOptions.sort)
            : {}),
          (e.customFilters = e._gridOptions.customFilters
            ? angular.copy(e._gridOptions.customFilters)
            : {}),
          (e.urlSync = e._gridOptions.urlSync),
          e.$watchCollection('_gridOptions.data', function (i) {
            i &&
              i.length > -1 &&
              ((e.sortCache = {}),
              (e.filtered = e._gridOptions.data.slice()),
              e.filters.forEach(function (i) {
                'select' === i.filterType &&
                  (e[i.model + 'Options'] = t(e.filtered, i.filterBy))
              }),
              e.urlSync ? l() : d())
          }),
          (e.sort = function (t, i) {
            if (!i) {
              var r =
                e.sortOptions.predicate === t &&
                'desc' === e.sortOptions.direction
                  ? 'asc'
                  : 'desc'
              ;(e.sortOptions.direction = r), (e.sortOptions.predicate = t)
            }
            ;(e.paginationOptions.currentPage = 1), e.reloadGrid(i)
          }),
          (e.filter = function () {
            ;(e.paginationOptions.currentPage = 1), e.reloadGrid()
          }),
          e.$on('$locationChangeSuccess', function () {
            s()
          }),
          e.$on('$stateChangeSuccess', function (t, e) {
            s()
          }),
          (e.reloadGrid = function (t) {
            e.urlSync || e.serverPagination ? c(t) : d(),
              i.$broadcast('gridReloaded')
          }),
          (e._gridActions.refresh = e.reloadGrid),
          (e._gridActions.filter = e.filter),
          (e._gridActions.sort = e.sort)
      }
    ])
    .directive('gridItem', [
      '$compile',
      function (t) {
        return {
          restrict: 'EA',
          terminal: !0,
          scope: !1,
          link: function (e, i, r, n, a) {
            e.serverPagination
              ? i.attr('ng-repeat', 'item in filtered')
              : i.attr(
                  'ng-repeat',
                  'item in filtered | startFrom:(paginationOptions.currentPage-1)*paginationOptions.itemsPerPage | limitTo:paginationOptions.itemsPerPage track by $index'
                ),
              i.removeAttr('grid-item')
            var o = i[0].outerHTML
            i.replaceWith(t(o)(e))
          }
        }
      }
    ])
    .directive('gridData', [
      '$compile',
      '$animate',
      function (e) {
        return {
          restrict: 'EA',
          scope: !0,
          controller: 'gridController',
          link: function (i, r, n) {
            var a = [],
              o = r.parent(),
              s = n.id,
              c = 'true' === n.serverPagination
            ;(i.serverPagination = c),
              angular.forEach(
                angular.element(o[0].querySelectorAll('[sortable]')),
                function (t) {
                  var r = angular.element(t),
                    n = r.attr('sortable')
                  r.attr(
                    'ng-class',
                    "{'sort-ascent' : sortOptions.predicate ==='" +
                      n +
                      "' && sortOptions.direction === 'asc', 'sort-descent' : sortOptions.predicate === '" +
                      n +
                      "' && sortOptions.direction === 'desc'}"
                  ),
                    r.attr('ng-click', "sort('" + n + "')"),
                    e(r)(i)
                }
              ),
              angular.forEach(
                document.querySelectorAll('[filter-by]'),
                function (e) {
                  var n = angular.element(e),
                    o = n.attr('filter-by'),
                    c = document.querySelectorAll('[grid-data]')[0],
                    l =
                      c.querySelectorAll('[filter-by="' + o + '"]').length > 0,
                    p = n.attr('filter-type') || '',
                    d = n.attr('ng-model'),
                    g = n.attr('disable-url')
                  ;(s && n.attr('grid-id') && s != n.attr('grid-id')) ||
                    ('select' !== p ||
                      (i[d + 'Options'] = t(
                        i.$eval(r.attr('grid-options') + '.data'),
                        o
                      )),
                    !~p.indexOf('date') ||
                      n.attr('ng-focus') ||
                      n.attr('ng-blur') ||
                      (n.attr(
                        'ng-focus',
                        "filter('{" + d + ' : this.' + d + "}')"
                      ),
                      n.attr(
                        'ng-blur',
                        "filter('{" + d + ' : this.' + d + "}')"
                      )),
                    d ||
                      ((d = o),
                      n.attr('ng-model', o),
                      n.attr('ng-change', 'filter()')),
                    a.push({
                      model: d,
                      isInScope: l,
                      filterBy: o,
                      filterType: p,
                      disableUrl: g
                    }))
                }
              ),
              (i.filters = a)
          }
        }
      }
    ])
    .factory('filtersFactory', function () {
      function t (t, e, i) {
        return t.filter(function (t) {
          return !e || !t[i] || t[i] === e
        })
      }
      function e (t, e, i) {
        return t.filter(function (t) {
          return e && t[i]
            ? ~(t[i] + '').toLowerCase().indexOf((e + '').toLowerCase())
            : !!t[i]
        })
      }
      function i (t, e, i) {
        return (
          (e = new Date(e).getTime()),
          t.filter(function (t) {
            return !e || !t[i] || t[i] <= e + 86399999
          })
        )
      }
      function r (t, e, i) {
        return (
          (e = new Date(e).getTime()),
          t.filter(function (t) {
            return !e || !t[i] || t[i] >= e
          })
        )
      }
      return {
        getFilterByType: function (n) {
          switch (n) {
            case 'select':
              return t
            case 'text':
              return e
            case 'dateTo':
              return i
            case 'dateFrom':
              return r
            default:
              return null
          }
        }
      }
    })
})()
